import * as Yup from 'yup';

import { validateApprovalPassword } from 'utils/validation';
import { CloverVoidReason, CloverVoidReasonTitle } from 'types';

import { FormValues } from './types';

export const getInitialValues = (deviceId?: number): FormValues => ({
  voidReason: '',
  approvalPassword: '',
  deviceId: deviceId || undefined,
});

export const validationSchema = Yup.object().shape({
  deviceId: Yup.number().required(),
  voidReason: Yup.string().required(),
  approvalPassword: validateApprovalPassword,
});

export const voidReasonOptions = Object.values(CloverVoidReason).map(
  (value) => ({ value, label: CloverVoidReasonTitle[value] })
);
